import * as types from './types'

export default {
  [types.MUTATE_TASKS]: (state, payload) => {
    state.tasks = payload
  },
  [types.MUTATE_MILESTONES]: (state, payload) => {
    state.milestones = payload
  },
  [types.MUTATE_SECONDARY_GOALS]: (state, payload) => {
    state.secondaryGoals = payload
  },
}
